





























import { Component, Vue, Prop } from "vue-property-decorator";
import moment from "moment";
import fb from "@/firebaseConfig";
import * as apiEvents from "@/api/events";

@Component
export default class DeleteEvent extends Vue {
  loading = false;

  @Prop()
  value!: any;
  @Prop()
  eventName!: any;
  @Prop()
  eventId!: any;

  deleteEvent() {
    this.loading = true;

    apiEvents
      .deleteEvent(this.eventId)
      .then(() => {
        this.$emit("input");
        this.$emit("delete");
      })
      .catch((error: any) => {
        console.log("error");
        console.log(error);
      })
      .finally(() => {
        this.loading = false;
      });
  }
}
